import { useState } from 'react'
import { Card, CardHeader, CardBody, Button, Label, FormFeedback, Alert, Spinner } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { DROP_SCHEMA_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils.js'
import { gql } from '@apollo/client'
import { FaArrowLeft } from 'react-icons/fa'
import SchemaSelect from './SchemaSelect'

const DROP_SCHEMA = gql(DROP_SCHEMA_MUTATION)

export default function DropSchema() {
  console.log('DropSchema rendered')

  const { inputs, handleInputChange, resetInputs } = useForm({ schemaName: '' }, handleSubmit)
  const [schemaNameState, setSchemaNameState] = useState({ state: '', message: '' })
  const [spinner, setSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [schemaDropped, setSchemaDropped] = useState(false)

  function startOver() {
    resetInputs({ schemaName: '' })
    setSchemaDropped(false)
  }

  async function handleSubmit() {
    console.log('DropSchema.handleSubmit: ', inputs.schemaName)
    if (!inputs.schemaName) {
      setGraphQLErrors([])
      setSchemaNameState({ state: 'has-danger', message: 'Schema Name is required.' })
    } else {
      setSchemaNameState({ state: '', message: '' })
      setSpinner(true)
      try {
        const { data, errors } = await window.apolloClient.mutate({ mutation: DROP_SCHEMA, variables: { schemaName: inputs.schemaName } })
        if (data.dropSchema === 'SUCCESS!') {
          setGraphQLErrors([])
          setSchemaDropped(true)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setSpinner(false)
      }
    }
  }

  let button =  <Button color="danger" onClick={handleSubmit}>Drop Schema</Button>
  if (spinner) {
    button = <Button disabled color="danger"><Spinner size="sm" /> Dropping schema...</Button>
  }

  let cardBody = 
    <CardBody>
      <Alert color="danger" isOpen={graphQLErrors.length ? true : false}>{graphQLErrors.length ? graphQLErrors[0].message : ''}</Alert>
      <Label for="schemaName">Schema</Label>
      <SchemaSelect
        inputName={'schemaName'}
        handleChange={handleInputChange}
        invalid={schemaNameState.state === 'has-danger'}
        valid={schemaNameState.state === 'has-success'}
      />
      <FormFeedback>{schemaNameState.message}</FormFeedback>
      <div style={{ paddingTop: '10px', textAlign: 'center' }}>
        {button}
      </div>
    </CardBody>

  if (schemaDropped) {
    cardBody = 
      <CardBody>
        <Alert color="success">{`Schema ${inputs.schemaName.toUpperCase()} was dropped successfully!`}</Alert>
        <div style={{ textAlign: 'center' }}>
          <Button style={{ float: 'left' }} onClick={startOver}><FaArrowLeft /> Start Over</Button>
        </div>
      </CardBody>
  }

  return (
    <Card style={{ maxWidth: '500px', marginTop: '20px' }}>
      <CardHeader style={{ fontWeight: 'bold' }}>Drop Schema</CardHeader>
      {cardBody}
    </Card>
  )
}
